import PropTypes from "prop-types";
import clsx from "clsx";
import { Link } from "react-router-dom";

const Logo = ({ imageUrl, logoClass, isNewHeader }) => {
  return (
    <div className={clsx(logoClass)}>
      <Link to={process.env.PUBLIC_URL + "/"}>
        {/* header-bussiness-logo */}
        {/* <div className="header-bussiness-logo" style={{backgroundImage:`url(${imageUrl})`}}/> */}
        <img
          style={{ maxWidth: isNewHeader && "244px" }}
          className={`${isNewHeader ? "" : ""} logo-header-img`}
          alt=""
          src={imageUrl}
        />
      </Link>
    </div>
  );
};

Logo.propTypes = {
  imageUrl: PropTypes.string,
  logoClass: PropTypes.string,
};

export default Logo;
